/** Easing functions. Used for arc position, luminance envelopes, camera lerps. */
export const easeInOutCubic = (t: number) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

export const easeOutQuint = (t: number) => 1 - Math.pow(1 - t, 5);

export const easeInQuint = (t: number) => t * t * t * t * t;

export const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

export const clamp01 = (t: number) => Math.max(0, Math.min(1, t));

export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

/** Critically-damped spring smoothing for scalar values. */
export class Damped {
  constructor(
    public value: number,
    public target: number = value,
    private readonly halfLifeMs = 400,
  ) {}

  update(dtMs: number) {
    // Exponential approach — stable regardless of frame time.
    const k = 1 - Math.pow(0.5, dtMs / this.halfLifeMs);
    this.value += (this.target - this.value) * k;
  }
}
